import { InjectionToken, Signal } from '@angular/core';

/**
 * Abstraction the SPA shell top bar consumes to render the "Toggle Debug Login Wrapper"
 * `manage_accounts` icon, immediately left of the Org dropdown (owner UX critique, 2026-09-14:
 * the drawers used to be toggled from their OWN header bar above the portal -- a bar that ate a
 * fixed 44px strip and existed only to hold one button. That bar is gone; the SAME toggle now
 * lives in the top nav bar app.component.ts already renders).
 *
 * Provided by the debug wrapper ({@link DebugShellComponent}) at its element-injector level so
 * the nested `<tb-root>` can flip the wrapper's paired debug drawers (actual-user picker + mock
 * phone on the left, HTTP/bank-event log on the right) WITHOUT app.component.ts statically
 * importing debug-shell code (FE-3 tree-shaking) -- the same DI-token seam
 * {@link TB_PERSONA_SWITCHER} (../demo/persona-switch.model.ts) already uses for the same reason.
 *
 * ABSENT in the bff build (no debug wrapper at all) and during the wrapper's own login phase
 * (before `<tb-root>` mounts) -- app.component.ts renders the icon only when this token resolves,
 * so a plain customer/demo session never sees debug chrome.
 */
export interface DebugDrawersController {
  /** True when both debug drawers are open. */
  readonly drawersOpen: Signal<boolean>;
  /** Toggle both drawers open/closed as a pair. */
  toggle(): void;
}

export const TB_DEBUG_DRAWERS = new InjectionToken<DebugDrawersController>('TB_DEBUG_DRAWERS');
